import { Group } from '@mantine/core';
import { Icon, Text } from '@repo/foundations';
import type { ReactNode } from 'react';

interface DeletedResourceWarningProps {
	children: ReactNode;
	strikethrough?: boolean;
	'aria-label'?: string;
}

export function DeletedResourceWarning({
	children,
	strikethrough = false,
	'aria-label': ariaLabel = 'This resource has been deleted',
}: DeletedResourceWarningProps) {
	return (
		<Group spacing="3xs" role="alert" aria-label={ariaLabel}>
			<Icon
				name="alertTriangleFilled"
				size="md"
				color="icon/warning/default"
				aria-hidden="true"
			/>
			<Text td={strikethrough ? 'line-through' : undefined} size="xs">
				{children}
			</Text>
		</Group>
	);
}
